import type React from 'react';
import type { ButtonProps } from '@mui/material';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

type LoadingButtonProps = ButtonProps & {
  isLoading: boolean;
};

export const LoadingButton: React.FC<LoadingButtonProps> = ({ isLoading, disabled, children, ...props }) => {
  return (
    <Button {...props} disabled={isLoading || disabled} variant="contained">
      {isLoading ? <CircularProgress color="info" size="22px" /> : children}
    </Button>
  );
};
